import { collection, doc, getDocs, query, where, serverTimestamp } from 'firebase/firestore';

export async function findDataFieldCandidate(db, field) {
  if (!field?.fieldName) return null;
  const matches = await getDocs(query(collection(db, 'documentDataFields'),
    where('fieldName', '==', field.fieldName)));
  return matches.docs[0]?.ref || doc(db, 'documentDataFields', field.fieldName);
}

// All reads must finish before the caller writes any part of its transaction.
export async function readDataFieldRegistration(transaction, db, field, candidate) {
  if (!candidate) return null;
  if (field.referenceId) {
    const ref = doc(db, 'documentDataFields', field.referenceId);
    const snapshot = await transaction.get(ref);
    if (snapshot.exists() && (snapshot.data().fieldName || ref.id) === field.fieldName) {
      return { ref, snapshot };
    }
  }
  let ref = candidate;
  let snapshot = await transaction.get(ref);
  let suffix = 0;
  // A deterministic field ID can remain occupied after a field rename.
  while (snapshot.exists() && (snapshot.data().fieldName || ref.id) !== field.fieldName) {
    const id = suffix ? `${field.fieldName}_${suffix}` : field.fieldName;
    suffix += 1;
    if (ref.id === id) continue;
    ref = doc(db, 'documentDataFields', id);
    snapshot = await transaction.get(ref);
  }
  return { ref, snapshot };
}

export function writeDataFieldRegistration(transaction, registration, field) {
  if (!registration || registration.snapshot.exists()) return;
  transaction.set(registration.ref, {
    fieldName: field.fieldName,
    displayName: field.displayName,
    description: '',
    category: field.category || 'New',
    showInHistoryFields: field.showInHistoryFields ?? true,
    ...(field.createdBy ? { createdBy: field.createdBy } : {}),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
